import { render, staticRenderFns } from "./QuizStudentEwallet.vue?vue&type=template&id=3008c5d4&"
import script from "./QuizStudentEwallet.vue?vue&type=script&lang=js&"
export * from "./QuizStudentEwallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports